import { format } from 'date-fns'
import { XAxis as RechartsXAxis } from 'recharts'

import { getDate } from '../../../app/header/utils'
import { CARTESIAN_STROKE } from './constants'

export enum DateFormat {
  MonthSingleChar = 'MMMMM',
  MonthShort = 'MMM',
  MonthShortDayNum = 'MMM dd',
  MonthShortYear = 'MMM yyy',
  MonthShortDayNumYearFull = 'MMM dd, yyyy',
  QuarterShort = 'QQQ',
  QuarterYearLong = 'QQQ yyyy',
}

const TICK_STYLE = {
  fontSize: 10,
  fontWeight: 400, // Different from YAxis
  fill: '',
}

export function dateAxisFormatter({
  value,
  outFormat,
  parseAsNY = false,
  breakOnYear = false,
}: {
  value: any
  outFormat: DateFormat
  parseAsNY?: boolean
  breakOnYear?: boolean
}) {
  if (!Number.isFinite(new Date(value).getTime())) return ''

  const date = parseAsNY ? getDate(value) : new Date(value)

  if (breakOnYear && date.getMonth() === 0) {
    if ([DateFormat.MonthSingleChar, DateFormat.MonthShort].includes(outFormat))
      return date.getFullYear().toString().substring(2)
    return date.getFullYear().toString()
  }

  return format(date, outFormat)
}

export class XAxis extends RechartsXAxis {
  static defaultProps = {
    ...RechartsXAxis.defaultProps,
    className: 'fill-gray-500 dark:fill-gray-300',
    tickLine: false,
    axisLine: false,
    dy: 5,
    tick: TICK_STYLE,
    dataKey: 'date',
    scale: 'time',
    type: 'number',
    interval: 'equidistantPreserveStart',
  }
}

export const SOLID_AXIS_LINE = { stroke: 'currentColor', className: CARTESIAN_STROKE }
